import { createSelector } from '@ngrx/store';
import * as fromFeature from '../../../../cep/store/reducers.index';
import * as  fromLogoutReducer from  '../reducer/logout.reducer';

export const logoutState = createSelector(
	fromFeature.getCEPState,
	(state: fromFeature.CEPState) => state.login
);